
// Carrossel de benefícios na página inicial
$(document).ready(function() {
  $('.benefits-line__container').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000, // 5 segundos por padrão, ajustável via configurações
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // Atualiza a velocidade do carrossel com base nas configurações da seção
  var carouselSpeed = $('.benefits-line').data('carousel-speed') * 1000 || 5000;
  $('.benefits-line__container').slick('slickSetOption', 'autoplaySpeed', carouselSpeed, true);
  
  // Carrossel de avaliacoes na página inicial
  $('.avaliacoes-loja__grid').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000, // 5 segundos por padrão, ajustável via configurações
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // carrossel da home
  $('.slideshow-wrapper .slideshow').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    // nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
    // prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000
  });

  // carrossel para vitrines
  $('.collection slider-component .product-grid').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    // nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
    // prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000, // 5 segundos por padrão, ajustável via configurações
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});